import { View, Text } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import styles from '../common/styles';
import { ContactDTO } from '@behavior/inventories/dto/ContactDTO';
import { PersonDTO } from '@behavior/inventories/dto/PersonDTO';

type Props = {
  width: number;
  contactTable: {
    header: string[];
    data: Array<keyof PersonDTO>;
  };
  contacts: Array<ContactDTO>;
};

export const ActivityContactTable = ({ width, contactTable, contacts }: Props) => {
  const { t } = useTranslation();

  return (
    <View style={[styles.thinRoundBorder]}>
      <View style={styles.accordianSubTitle}>
        <Text>{t('activity.report.page.components.activity.contact')}</Text>
      </View>
      <View style={styles.table}>
        <View style={styles.tableRow}>
          {contactTable.header.map(colName => {
            return (
              <View style={[{ width: width }, styles.bold]}>
                <Text>{colName}</Text>
              </View>
            );
          })}
        </View>
        {contacts.map(contact => {
          return (
            <View style={styles.tableRow}>
              {contactTable.data.map(colName => {
                return (
                  <View style={[{ width: width }, styles.bold]}>
                    <Text>{contact.person[colName]}</Text>
                  </View>
                );
              })}
            </View>
          );
        })}
      </View>
    </View>
  );
};
